module.exports = __webpack_public_path__ + "static/media/food-chains-in-peril-desktop.940f2bc2.jpg";